import {amplitude} from './index';

export const logEvent = (
  eventName: string,
  eventData: Record<string, unknown> = {}
) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(':: TRACKING EVENT :: \n', eventName, eventData);
  }

  amplitude.logAmplitudeEvent(eventName, eventData);
};
